export default __webpack_public_path__ + "images/50c7a07753ef7618606de90510867a33.png";